import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../../store/store";
import { fetchToken, loginUser } from "../../store/authSlice";

const Login: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const idToken = useSelector((state: RootState) => state.auth.idToken)
    const roles = useSelector((state: RootState) => state.auth.roles)
    useEffect(() => {

        const authenticateUser = async () => {
            try {

                await dispatch(fetchToken()).unwrap();
                navigate('/home')

            }
            catch (error) {
                dispatch(loginUser())

            }
        }
        if (!idToken) {
            authenticateUser()
        }
        else {
            navigate('/home')
        }
    }, [dispatch, navigate, idToken, roles])




    return (

        <div className="page-not-input">
            <h1 className="color">Loading..</h1>
            <span className="text-spacing">Please wait while we set up your access</span>
        </div>
    )
}

export default Login;